import { styled } from '@mui/material';
import { HFlex } from '../FlexContainers';

export const PricingLabelContainer = styled(HFlex)`
  align-items: center;
`;

export const PricingContainer = styled(HFlex)`
  gap: 5px 20px;
  flex-wrap: wrap;
  align-items: center;
`;